<template>
    <div :id="component_data.id" class="custom03_wrapper font-responsive">
        <div class="custom03_contents w-5/6 mobile:w-full mobile:flex-column mobile-sides mx-auto">
            <div class="custom03_visual w-1/2 mobile:w-full r-2/1">
                <img :src="component_data.params.img.src" :alt="component_data.params.img.alt">
                <div class="feat_video feat_video_r">
                    <video-block v-if="component_data.params.video" :component_data="component_data.params.video"> </video-block>
                </div>
            </div>
            <article class="custom03_caption w-1/3 mobile:w-full mx-auto">
                <header>
                    <figure class="custom03_icon" v-html="component_data.params.icon"></figure>
                    <h2 v-html="component_data.params.title"></h2>
                </header>
                <div class="custom03_texts">
                    <p v-for="(text, index) in texts(component_data.params)" v-html="text" :key="index"></p>
                </div>
            </article>
        </div>
    </div>
</template>

<script>
import video from '@/components/videoBlock/video'

export default {
    props: ['component_data'],
    data(){
        return {
            
        }
    },
    mounted(){
        this.$nextTick(()=>{
            
        })
    },
    components: {
        "video-block": video
    }
}
</script>

<style lang="scss">

    .custom03_wrapper {
        overflow: hidden;
        position: relative;
        margin: 60px 0;
    }

    .custom03_wrapper::before {
        content: '';
        height: 100%;
        width: 66.66%;
        position: absolute;
        background-color: #FAF9F7;  
        
        @media screen and (max-width: 992px) {
          width: 100%;
        }
    }
    .custom03_contents {
        position: relative;
        margin: 0 auto;
        display: flex;
        align-items: center;
    }
    .custom03_visual {
        position: relative;
        z-index: 0;
        margin: 4em 0;
    }
    .custom03_video img {
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
    .custom03_caption {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 3em 0;

        @media screen and (max-width: 992px) {
          padding-left: 10%;
        }
    }
    .custom03_caption header {
        display: flex;
        align-items: center;
        margin-bottom: 4.5em;
    }
    .custom03_caption header h2 {
        color: #E41429;
        line-height: 1.41em;
        font-size: 3.8em;
        font-weight: 700;
        margin: 0 0 0 1.25em;
        padding-right: 0.625em;
        font-family: 'Uni Neue', sans-serif;
    }
    .custom03_texts {
        padding: 0 3em;
    }
    .custom03_caption p {
        font-size: 2em;
        line-height: 1.9em;
        font-family: 'Lato', sans-serif;
    }
    .custom03_icon {
        margin: 0;
    }
    .custom03_icon svg {
        width: 10em;
        height: 10em;
        border-radius: 8px;
        color: white;
        background-color: #E41429;
        margin: 0;
    }
    .custom03_wrapper img {
        max-width: 100%;
    }

    .custom03_contents {
        flex-direction: row-reverse;
    }
    .custom03_visual>img {
        position: absolute;
        top: 0; left: 0;
        border-top-left-radius: 60px;
        object-fit: cover;
        height: 100%;
        width: 100%;

    }
    .custom03_wrapper::before { 
        border-bottom-left-radius: 60px;
        left: 8.333%;
    }

    .feat_video {
        bottom: -6em;
        display: flex;
        position: absolute;
        height: 10.2234vw;
        width: 16.5vw;        
        left: -6em;
        bottom: -6em;  
        z-index: 1;

        @media screen and (max-width: 992px) {
          bottom: -3em;
          height: 20vw;
          left: -3em;
          width: 30vw;
        }
    }
    .feat_video::before {
        content: '';
        width:100%;
        height: 100%;
        background-color: #E41429;
        position: absolute;
        bottom: 3em;
        left: 3em;
        border-top-right-radius: 3em;

        @media screen and (max-width: 992px) {
          bottom: 1.5em;
          left: 1.5em;
        }
    }
    .feat_video img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        border-top-left-radius: 3em; 
    }
    .feat_video .avc_thumb{
        border-top-left-radius: 3em; 
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @media (min-width: 1920px){
        .feat_video {
            width: 303px;
            height: 188px;            
        }       
    }
</style>
